import React, { useState } from 'react';
import Image from 'next/image';

import { IHeader2Fields } from '../../../../../../types/contentful';

import { useEscapeEvent } from '../../../../../hooks/useEscapeEvent';

import { NavigationLink } from './DesktopNavLink';
import CtaWidget from '../../../../CtaWidget';
import Link from '../../../../Link';

import {
  DesktopNavbarContainer,
  DesktopNavbarColumn,
  LogoWrapper,
  LinksContainer
} from '../DesktopNavbar.styles';

import fullLogo from '@/images/gl-logo-full.svg';
import abbreviatedLogo from '@/images/gl-logo-abbreviated.svg';

interface Props extends Partial<IHeader2Fields> {
  isScrolled: boolean;
  isSimplified: boolean;
}

export function DesktopNavbar({
  isScrolled,
  isSimplified,
  navItems,
  desktopCta
}: Props) {
  const [selected, setSelected] = useState<string | undefined>(undefined);

  useEscapeEvent(() => setSelected(undefined));

  return (
    <DesktopNavbarContainer isScrolled={isScrolled}>
      <DesktopNavbarColumn>
        <Link href="/">
          {isScrolled ? (
            <LogoWrapper>
              <Image alt="Greenlight logo" src={abbreviatedLogo} />
            </LogoWrapper>
          ) : (
            <Image alt="Greenlight logo" src={fullLogo} />
          )}
        </Link>

        <LinksContainer
          data-testid="desktop-navlinks"
          isSimplified={isSimplified}
        >
          {navItems &&
            navItems.map(({ fields }: any, idx: number) => (
              <NavigationLink
                {...fields}
                key={idx}
                selected={selected === (fields?.name || fields?.title)}
                setSelected={setSelected}
              />
            ))}
        </LinksContainer>

        <CtaWidget
          {...desktopCta?.fields}
          id="desktop-nav-cta"
          sysId={desktopCta?.sys?.contentType?.sys?.id}
          module="Navigation"
        />
      </DesktopNavbarColumn>
    </DesktopNavbarContainer>
  );
}
